const mill = {
  namespaced: true,
  state: {
    application: {
      millId: null,
      millName: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      mState: "",
      pincode: "",
      installedSpdls: Number(""),
      installedRotors: Number(""),
      installedSLooms: Number(""),
      installedSlLooms: Number(""),
      gstNo: "",
    },
    requirement: {
      jobTitle: "",
      noOfPosts: Number(""),
      qualification: [],
      approxSalary: Number(""),
      experience: "",
      millpackage: "",
      packageFee: Number(""),
    },
  },
  mutations: {
    updateMillId(state) {
      state.millId = sessionStorage.getItem("millId");
    },
    updatemillName(state, millName) {
      state.application.millName = millName;
    },
    updateaddress1(state, address1) {
      state.application.address1 = address1;
    },
    updateaddress2(state, address2) {
      state.application.address2 = address2;
    },
    updateaddress3(state, address3) {
      state.application.address3 = address3;
    },
    updatecity(state, city) {
      state.application.city = city;
    },
    updatestate(state, mState) {
      state.application.mState = mState;
    },
    updatepincode(state, pincode) {
      state.application.pincode = pincode;
    },
    updateinstalledRotors(state, installedRotors) {
      state.application.installedRotors = installedRotors;
    },
    updateinstalledSpdls(state, installedSpdls) {
      state.application.installedSpdls = installedSpdls;
    },
    updateinstalledSLooms(state, installedSLooms) {
      state.application.installedSLooms = installedSLooms;
    },
    updateinstalledSlLooms(state, installedSlLooms) {
      state.application.installedSlLooms = installedSlLooms;
    },
    updategstNo(state, gstNo) {
      state.application.gstNo = gstNo;
    },
    updatejobTitle(state, jobTitle) {
      state.requirement.jobTitle = jobTitle;
    },
    updatenoOfPosts(state, noOfPosts) {
      state.requirement.noOfPosts = noOfPosts;
    },
    updatequalification(state, qualification) {
      state.requirement.qualification = qualification;
    },
    updateapproxSalary(state, approxSalary) {
      state.requirement.approxSalary = approxSalary;
    },
    updateexperience(state, experience) {
      state.requirement.experience = experience;
    },
    updatemillpackage(state, millpackage) {
      state.requirement.millpackage = millpackage;
    },
    updatepackageFee(state, packageFee) {
      state.requirement.packageFee = packageFee;
    },
  },
  actions: {
    updatemillName({ commit }, millName) {
      commit("updatemillName", millName);
    },
    updateaddress1({ commit }, address1) {
      commit("updateaddress1", address1);
    },
    updateaddress2({ commit }, address2) {
      commit("updateaddress2", address2);
    },
    updateaddress3({ commit }, address3) {
      commit("updateaddress3", address3);
    },
    updatecity({ commit }, city) {
      commit("updatecity", city);
    },
    updatestate({ commit }, mState) {
      commit("updatestate", mState);
    },
    updatepincode({ commit }, pincode) {
      commit("updatepincode", pincode);
    },
    updateinstalledRotors({ commit }, installedRotors) {
      commit("updateinstalledRotors", installedRotors);
    },
    updateinstalledSpdls({ commit }, installedSpdls) {
      commit("updateinstalledSpdls", installedSpdls);
    },
    updateinstalledSLooms({ commit }, installedSLooms) {
      commit("updateinstalledSLooms", installedSLooms);
    },
    updateinstalledSlLooms({ commit }, installedSlLooms) {
      commit("updateinstalledSlLooms", installedSlLooms);
    },
    updategstNo({ commit }, gstNo) {
      commit("updategstNo", gstNo);
    },
    updatejobTitle({ commit }, jobTitle) {
      commit("updatejobTitle", jobTitle);
    },
    updatenoOfPosts({ commit }, noOfPosts) {
      commit("updatenoOfPosts", noOfPosts);
    },
    updatequalification({ commit }, qualification) {
      commit("updatequalification", qualification);
    },
    updateapproxSalary({ commit }, approxSalary) {
      commit("updateapproxSalary", approxSalary);
    },
    updateexperience({ commit }, experience) {
      commit("updateexperience", experience);
    },
    updatemillpackage({ commit }, millpackage) {
      commit("updatemillpackage", millpackage);
    },
    updatepackageFee({ commit }, packageFee) {
      commit("updatepackageFee", packageFee);
    },
  },
};

export default mill;
